
import Transformer from './../transformer'
export default class SinisterNotificationTransformer extends Transformer {
  static fetch(sinister) {

    let data = {
        road_sinister_id: sinister.road_sinister_id,
        sinister_id: sinister.sinister_id,
        requisition_number: sinister.requisition_number,
        sinister_number: sinister.sinister_number,
        folio_jb: sinister.folio_jb,
        }
    return data
    }
}


// WEBPACK FOOTER //
// ./src/transformers/notification/sinisterNotification.js